export default __webpack_public_path__ + "static/media/SteffiLovelace.20e00d02.png";